
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...dynamicRoutes]]",
      function () {
        return require("private-next-pages/[[...dynamicRoutes]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...dynamicRoutes]]"])
      });
    }
  